import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import * as xlsx from "xlsx";
import { request } from "@/js/http/http_request";
import { getLimitedLocations } from "@/js/http/auth";
import { formRules } from "@/js/form_rules.js";
import { emptyCellContent, stockReservationTypes } from "@/js/lists.ts";
import { getFullNameUser } from "@/js/user/user.js";
export default {
  components: {
    MinusPlusInput: function MinusPlusInput() {
      return import("@/components/common/MinusPlusInput.vue");
    },
    UploaderV2: function UploaderV2() {
      return import("@/components/default/UploaderV2.vue");
    },
    Address: function Address() {
      return import("@/components/address/Address.vue");
    }
  },
  computed: {
    shown: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit("input", value);
      }
    },
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/stock/reconciliation?sku=").concat(this.form.sku, "&label=").concat(this.form.label, "&quantity=").concat(this.form.quantity, "&warehouse=").concat(this.form.warehouseId);
    }
  },
  props: {
    loggedUserData: Object,
    value: Boolean
  },
  created: function created() {
    this.fetchWarehouses();
  },
  data: function data() {
    return {
      searchValue: null,
      saveQuantityErrorMessage: [],
      deltaQuantities: [],
      isConfiguring: true,
      activeFilters: [],
      isSavingQuantity: [],
      editQuantityShown: true,
      editedItem: {},
      columns: [],
      items: [],
      cachedItems: [],
      defaultItems: [],
      isLoadingCountries: false,
      isUploading: false,
      quantityForm: {
        valid: false
      },
      form: {
        label: null,
        warehouseId: null,
        quantity: null,
        sku: null,
        valid: false
      },
      rules: formRules,
      warehouses: [],
      headers: [{
        text: "Line",
        value: "lineNumber",
        align: "center"
      }, {
        text: "",
        value: "status",
        align: "center"
      }, {
        text: "",
        value: "message",
        align: "center"
      }, {
        text: "SKU",
        value: "sku",
        align: "center"
      }, {
        text: "Description",
        value: "displayName",
        align: "center"
      }, {
        text: "File's quantity",
        value: "fileQuantity",
        align: "center"
      }, {
        text: "Platform's quantity",
        value: "globalWarehouseQuantity",
        align: "center"
      }, {
        text: "Stocks & Adjustment",
        value: "adjustment",
        align: "center"
      }, {
        text: "verified",
        value: "verified",
        align: "center"
      }],
      stockReservationTypes: stockReservationTypes,
      emptyCellContent: emptyCellContent
    };
  },
  methods: {
    saveQuantity: function saveQuantity(stock, item) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _item$stocks;
        var itemIndex, _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              itemIndex = _this2.items.indexOf(item);
              _this2.isSavingQuantity[stock.id_stock] = true;
              _this2.saveQuantityErrorMessage[stock.id_stock] = null;
              _this2.reRenderItem(item);
              _this = _this2;
              _context.next = 7;
              return request("/v1/stock/".concat(stock.id_stock, "/quantities/").concat(stock.adjustmentQuantity), "put", {}, true, "api").catch(function (e) {
                var _e$response$data$valu, _e$response;
                _this.saveQuantityErrorMessage[stock.id_stock] = (_e$response$data$valu = e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.value) === null || _e$response === void 0 ? void 0 : _e$response.message) !== null && _e$response$data$valu !== void 0 ? _e$response$data$valu : "Unable to save the new quantity. Please retry.";
                _this.isSavingQuantity[stock.id_stock] = false;
                item.verified = false;
                _this.items.splice(itemIndex, 1, _objectSpread({}, item));
                _this.defaultItems.splice(itemIndex, 1, _objectSpread({}, item));
                throw e;
              });
            case 7:
              response = _context.sent;
              stock.quantity += stock.adjustmentQuantity;
              item.globalWarehouseQuantity += stock.adjustmentQuantity;
              item.deltaQuantity = item.fileQuantity - item.globalWarehouseQuantity;
              if (((_item$stocks = item.stocks) === null || _item$stocks === void 0 ? void 0 : _item$stocks.length) === 1) {
                item.verified = true;
              }
              stock.adjustmentQuantity = 0;
              _this2.isSavingQuantity[stock.id_stock] = false;
              _this2.saveQuantityErrorMessage[stock.id_stock] = null;
              _this2.items.splice(itemIndex, 1, item);
              _this2.defaultItems.splice(itemIndex, 1, item);
              _this2.$toasted.show("Saved.", {
                type: "success"
              });
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    reRenderItem: function reRenderItem(item) {
      var itemIndex = this.items.indexOf(item);
      this.items.splice(itemIndex, 1, _objectSpread({}, item));
    },
    handleSearch: function handleSearch(value) {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.items = _this3.intersectItems(_this3.filterItemsByTags(), _this3.filterItemsByKeywords(value));
      });
    },
    handleClickTag: function handleClickTag(type) {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.items = _this4.intersectItems(_this4.filterItemsByTags(type), _this4.filterItemsByKeywords(_this4.searchValue));
      });
    },
    filterItemsByKeywords: function filterItemsByKeywords(value) {
      this.searchValue = value;
      if (!value) return _toConsumableArray(this.defaultItems);
      var predicate = function predicate(x) {
        return Object.values(x).join().toLowerCase().includes(value.toLowerCase());
      };
      var filteredItems = this.defaultItems.filter(predicate);
      return filteredItems;
    },
    filterItemsByTags: function filterItemsByTags(type) {
      var filteredItems = [];
      if (this.activeFilters.includes(type)) {
        this.activeFilters = this.activeFilters.filter(function (x) {
          return x !== type;
        });
      } else if (type) {
        this.activeFilters = [].concat(_toConsumableArray(this.activeFilters), [type]);
      }
      if (!this.activeFilters.length) return _toConsumableArray(this.defaultItems);
      if (this.activeFilters.includes("inventory")) {
        filteredItems = this.defaultItems.filter(function (x) {
          return x.isMissingInStock;
        });
      }
      if (this.activeFilters.includes("file")) {
        filteredItems = [].concat(_toConsumableArray(this.defaultItems.filter(function (x) {
          return x.isMissingInFile;
        })), _toConsumableArray(filteredItems));
      }
      if (this.activeFilters.includes("quantities")) {
        filteredItems = [].concat(_toConsumableArray(this.defaultItems.filter(function (x) {
          return !x.isMissingInFile && !x.isMissingInStock && x.deltaQuantity != 0;
        })), _toConsumableArray(filteredItems));
      }
      return filteredItems;
    },
    intersectItems: function intersectItems(a, b) {
      return a.filter(function (x) {
        return b.some(function (y) {
          return x.sku === y.sku;
        });
      });
    },
    startOver: function startOver() {
      this.isConfiguring = true;
      this.columns = [];
      this.items = [];
      this.form.sku = null;
      this.form.quantity = null;
      this.form.label = null;
      this.form.valid = false;
      this.activeFilters = [];
    },
    exportAs: function exportAs(type) {
      var worksheet = xlsx.utils.json_to_sheet(this.items.map(function (x) {
        return {
          line: x.lineNumber,
          sku: x.sku,
          description: x.displayName,
          fileQuantity: x.fileQuantity,
          warehouseQuantity: x.globalWarehouseQuantity,
          delta: x.deltaQuantity,
          message: x.message,
          verified: x.verified,
          isMissingInStock: x.isMissingInStock,
          isMissingWine: x.isMissingWine,
          isMissingInFile: x.isMissingInFile
        };
      }));
      var workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "inventory");
      xlsx.writeFile(workbook, "inventory_reconciliation." + (type || "xlsx"));
    },
    fetchWarehouses: function fetchWarehouses() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response, limitedLocations;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this5;
              _context2.next = 3;
              return request("/v1/warehouses", "post", {
                paging: null
              }, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load warehouses.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context2.sent;
              _this5.warehouses = _toConsumableArray(response.data.warehouses);
              limitedLocations = getLimitedLocations(_this5.loggedUserData);
              if ((limitedLocations === null || limitedLocations === void 0 ? void 0 : limitedLocations.length) > 0) {
                _this5.warehouses = _this5.warehouses.filter(function (item) {
                  return limitedLocations.some(function (loc) {
                    var _item$address$state;
                    return loc.state_id > 0 ? item.address.country.id_country === loc.country_id && ((_item$address$state = item.address.state) === null || _item$address$state === void 0 ? void 0 : _item$address$state.id_state) === loc.state_id : item.address.country.id_country === loc.country_id;
                  });
                });
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    submit: function submit() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var valid;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              valid = _this6.$refs.form.validate();
              if (valid) {
                _this6.isUploading = true;
                _this6.$refs.uploader.uploadAll();
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    uploadFailed: function uploadFailed() {
      this.isUploading = false;
    },
    acknowledgeUpload: function acknowledgeUpload(response) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _response$data$fileRo, _response$data$missin;
        var notMissingItems, missingItems;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              notMissingItems = ((_response$data$fileRo = response.data.fileRows) === null || _response$data$fileRo === void 0 ? void 0 : _response$data$fileRo.map(function (x) {
                x.isMissingInFile = false;
                if (x.isMissingInStock) {
                  x.message = "Reference was not found in the platform's stock initially.";
                  x.status = "danger";
                } else if (x.deltaQuantity != 0) {
                  x.message = "The quantities diverge initially.";
                  x.status = "warning";
                } else {
                  x.message = "";
                  x.status = "success";
                }
                return x;
              })) || [];
              missingItems = ((_response$data$missin = response.data.missingStocksInFile) === null || _response$data$missin === void 0 ? void 0 : _response$data$missin.map(function (x) {
                x.stocks = [_objectSpread({}, x)];
                x.isMissingInFile = true;
                x.message = "Reference was not found in the provided file initially.";
                x.status = "danger";
                x.sku = x.reference_warehouse;
                x.displayName = x.wine.display_name;
                x.globalWarehouseQuantity = x.quantity + x.quantity_committed;
                x.deltaQuantity = -x.globalWarehouseQuantity;
                return x;
              })) || [];
              _this7.items = [].concat(_toConsumableArray(notMissingItems), _toConsumableArray(missingItems));
              _this7.items.forEach(function (item) {
                item.verified = false;
                item.stocks.forEach(function (stock, i) {
                  if (stock.reservation_type === stockReservationTypes.SPECIFIC_CUSTOMER.id) {
                    stock.reservationLabel = getFullNameUser(stock.reservation_user);
                  } else if (stock.reservation_type === stockReservationTypes.SPECIFIC_CONSULTANT.id) {
                    stock.reservationLabel = getFullNameUser(stock.reservation_consultant);
                  } else {
                    stock.reservationLabel = Object.values(stockReservationTypes).find(function (x) {
                      return x.id === stock.reservation_type;
                    }).shortListLabel;
                  }
                  stock.adjustmentQuantity = i === 0 ? item.deltaQuantity : 0;
                  stock.boolRender = false;
                });
              });
              _this7.defaultItems = _toConsumableArray(_this7.items);
              _this7.isConfiguring = false;
              _this7.isUploading = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    close: function close() {
      this.$emit("input", false);
    },
    syncFiles: function syncFiles(files) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, workbook, wbJson, firstSheetName;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return files[0].arrayBuffer();
            case 2:
              data = _context5.sent;
              workbook = xlsx.read(data);
              wbJson = File.transformSheetToJson(workbook);
              firstSheetName = File.getFirstSheetName(wbJson);
              _this8.columns = wbJson[firstSheetName][0];
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    goToStock: function goToStock(idStock) {
      return {
        name: "adminStockDetails",
        query: {
          id_stock: idStock
        }
      };
    },
    goToCreateStock: function goToCreateStock(item) {
      return {
        name: "adminStockDetails",
        query: {
          id_wine: item.wineId,
          warehouseId: this.form.warehouseId,
          quantity: item.fileQuantity
        }
      };
    },
    goToProductList: function goToProductList(sku) {
      return {
        name: "adminProductList",
        query: {
          tab: "wines",
          searchLabel: sku
        }
      };
    }
  }
};